module.exports = __webpack_public_path__ + "img/image-conoce.0bb868cf.webp";